import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import AllergenDetailsForm from "../../../components/forms/setup/allergens/AllergenDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function AllergensViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [allergens, setAllergens] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getAllergens = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `allergens?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setAllergens(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createAllergen = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("allergens/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Allergen added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getAllergens("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateAllergen = async function (values, index) {
    let callResult = await makePutApiCall(`allergens/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Allergen updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...allergens.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setAllergens({ ...allergens, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddAllergenSlideOver = (isEdit, allergen, index) => {
    setSlideOver({
      childComponent: (
        <AllergenDetailsForm
          allergen={allergen}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateAllergen(payload, index) : createAllergen(payload)
          }
          title={isEdit ? `Update ${allergen.name}` : "Add new allergen"}
        />
      ),
      open: true,
    });
  };

  const deleteAllergen = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteAllergen/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = allergens.data.filter((item) => item.id !== id);
      setAllergens({ ...allergens, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteAllergen = function (allergen, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteAllergen(allergen.id, index)}
          message={`Are you sure you want to delete  ${allergen.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddAllergenSlideOver,
    getAllergens,
    loading,
    allergens,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteAllergen,
  };
}
